<template>
  <div class="purchase-detail-box">
    <v-title
      title="拜访记录"
      :isShowBack="true"
      :isDefaultBack="false"
      @backHandle="goBack()"
    >
    </v-title>
    <div class="purchase-header">
      <div class="noRecord" v-if="noRecord">
        <!-- <img :src="require('@/assets/images/noData.png')" alt=""> -->
        暂无记录
      </div>
      <div class="purchase-header-list" v-for="item in clientList" @click="goDetail(item.recordId)" :key="item.matchClientId">
        <div class="purchase-header-item clearfix">
          <span class="fl title">{{item.visitPersonName}}</span>
          <span class="fr">{{item.lastVisitTime}}</span>
        </div>
        <div class="purchase-header-item clearfix">
          <span class="fl">产品1数：{{item.productQuantity}}</span>
          <span class="fr">产品2数：{{item.competitiveProductQuantity}}</span>
        </div>
      </div>
    </div>
    <custom-loading v-if="loading" :isMask="true"></custom-loading>
  </div>
</template>
<script>
import CustomLoading from '@/components/CustomLoading.vue'
import { getClientVisitRecord } from '@/api/clientVisit'
export default {
  name: 'clientVisitRecords',
  components: {
    CustomLoading
  },
  computed: {},
  created () {
    console.log(111, this.$route.query.data)
    getClientVisitRecord(this.$route.query.data).then((res) => {
      if (res.code === 1) {
        this.clientList = res.data
        if (res.data.length === 0) {
          this.noRecord = true
        }
      }
    })
  },
  data () {
    return {
      noRecord: false,
      defaultAreaName: {},
      provinceList: [],
      prductModel: {},
      clientList: [],
      competitiveProductModel: {}
    }
  },

  filters: {
  },
  methods: {
    goDetail (recordId) {
      this.$router.push({
        name: 'visitDetail',
        query: {
          data: recordId
        }
      })
    },
    goBack () {
      // this.$router.push({name:'index'})
      this.$router.back()
    },
    // 回车事件
    submitHandle () {
      this.$emit('enter', this.keyword)
    },
    // 失去焦点时
    blurHandle () {
      this.$emit('blur', this.keyword)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/base/base.styl';

.purchase-detail-box {
  height: 100%;
  background: #efefef;
}

.purchase-header {
  padding-top: 110px;
  background: #efefef;

  .noRecord {
    padding-top: 10px
    background: #fff
    text-align: center
    height: 65px
    font-size: 30px;
  }
  .purchase-header-list {
    height: 180px
    padding 10px 30px
    margin-bottom: 20px
    background: #fff;
    .title {
      font-size: 30px;
      color: #333;
      font-weight: bold;
    }
    .purchase-header-item {
      margin-top: 5px
      margin-top: 24px;
      color: #666;
      font-size: 26px;
    }
  }
}

.purchase-main {
  top 100px
  padding 32px
  padding-top 100px
  background: #fff
  .purchase-main-list {
    background: #fff;
    margin-top: 10px;

    .purchase-main-list-item {
      border-bottom: 1px solid #efefef;
      padding-bottom: 36px;
      padding-top: 26px;
      color: #666;
      line-height: 1;
      font-size: 26px;
    }
  }
}
</style>
